module.exports = __webpack_public_path__ + "img/angels.5a0d2b70.svg";